import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { VehicleProfile } from 'src/app/demo/models/common-data-types';
import { VehiclesService } from 'src/app/demo/service/vehicles.service';
import { convertFileToBinaryString } from 'src/app/demo/utilities/file-utils';
import { ShowOutstandingDocumentsComponent } from '../../common/show-outstanding-documents/show-outstanding-documents.component';
import { ProgressLoaderService } from 'src/app/demo/service/progress-loader.service';
import { Message, MessageService } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';
import { ShowDocumentsComponent } from '../../common/show-documents/show-documents.component';
import { LanguageService } from 'src/app/demo/service/language.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessageModule } from 'primeng/message';
import { CustomToastrService } from 'src/app/demo/service/custom-toastr.service';

@Component({
    selector: 'app-vehicle-detail',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        CardModule,
        FileUploadModule,
        MessageModule,
        TranslateModule,
        CalendarModule,
        InputTextModule,
        FormsModule,
        ReactiveFormsModule,
        ShowOutstandingDocumentsComponent,
        ShowDocumentsComponent,
    ],
    templateUrl: './vehicle-detail.component.html',
    styleUrl: './vehicle-detail.component.scss',
    providers: [MessagesModule, MessageService],
})
export class VehicleDetailComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private translate: TranslateService,
        private toast: CustomToastrService,
        private languageService: LanguageService,
        private vehicleService: VehiclesService,
        private progressLoaderService: ProgressLoaderService,
        private wiseToastr: CustomToastrService,
        private messageService: MessageService
    ) {}
    messages: Message[] = [];
    vehicleId!: string;
    vehicle!: VehicleProfile;
    documentForm!: FormGroup;
    selectedLanguage: any = null;

    ngOnInit() {
        this.route.paramMap.subscribe((params) => {
            this.vehicleId = params.get('id')!;
            this.fetchVehicle();
        });
        this.initializeLocale();
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }

    goToVehiclesListing() {
        this.router.navigate(['/home/vehicles']);
    }

    fetchVehicle() {
        this.progressLoaderService.show('Fetching vehicle profile...');
        this.vehicleService.getVehicleProfile(this.vehicleId).subscribe({
            next: (value) => {
                this.progressLoaderService.hide();
                this.vehicle = value;
            },
            error: (err) => {
                this.progressLoaderService.hide();
                this.toast.showError(this.translate.instant(err.error.messageKey))
            },
        });
    }

    documentUploaded(formData: FormData) {
        this.progressLoaderService.show('Uploading file ...');
        this.vehicleService
            .uploadDocument(this.vehicle.vehicle.id, formData)
            .subscribe({
                next: (value) => {
                    this.showSuccessToast('Document upload successful');
                    this.progressLoaderService.hide();
                    this.vehicle = value;
                    if (this.vehicle.outstandingDocuments.length === 0) {
                        this.router.navigate(['/home/vehicles']);
                    }
                },
                error: (err) => {
                    this.progressLoaderService.hide();
                    this.toast.showError(this.translate.instant(err.error.messageKey))
                },
            });
    }

    onUpload(event: any) {
        const files = event.files;
        if (files.length > 0) {
            const firstFile = files[0];
            convertFileToBinaryString(firstFile);
        }
    }

    showSuccessToast(message: string) {
        this.wiseToastr.showSuccess(message);
    }

    showErrorToast(message: string) {
        this.wiseToastr.showError(message);
    }
}
